
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 217","transform":"translate(-91 -769)"}},[_c('circle',{attrs:{"data-name":"Ellipse 19","cx":"16","cy":"16","r":"16","transform":"translate(91 769)","fill":"#3a3a3a"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 349","d":"M107.642 774.012c.422.056.85.105 1.272.174a10.316 10.316 0 012.166.621c-.155.4-.31.782-.472 1.185a9.62 9.62 0 00-8.57.683 9.232 9.232 0 00-4.226 5.17 9.713 9.713 0 1016.961-2.6c-.043.323-.087.621-.13.937-.428-.056-.844-.112-1.272-.161.124-.993.248-1.961.379-2.948h2.942v1.266h-.943c.062.093.093.149.137.2a10.812 10.812 0 012.079 5.641c.006.062.025.124.037.186v1.334l-.037.186c-.093.577-.143 1.167-.273 1.731a10.954 10.954 0 01-8.775 8.223c-.41.068-.819.112-1.229.168h-1.337l-.186-.037c-.577-.087-1.167-.143-1.731-.273a11.017 11.017 0 01-8.266-8.8c-.068-.4-.112-.807-.168-1.21v-1.374c.056-.41.1-.819.168-1.229a10.991 10.991 0 018.893-8.912c.416-.068.832-.118 1.254-.174.44.013.885.013 1.327.013z"}}),_c('path',{attrs:{"data-name":"Path 350","d":"M107.003 792.27a7.261 7.261 0 117.255-7.255 7.273 7.273 0 01-7.255 7.255zm2.973-7.968h-2.284v-2.266h-1.378v3.655h3.662z"}})])])])
          )
        }
      }
    